export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1760_.577f6293.jpg";